import React from 'react';
import { Grid, Box } from '@mui/material';
import TeamTemplateEditSidenav from './TeamTemplateEditSidenav';

const TeamTemplateEditLayout = ({
    onMenuItemClick,
    selectedItem,
    mainContent,
    previewContent
}) => {
    return (
        <Grid container sx={{ height: '100%', padding: 1, overflow: 'hidden' }}>
            <Grid
                item
                xs={12}
                sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'row',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    backgroundColor: '#ffffff',
                }}
            >
                {/* Sidebar */}
                <Grid
                    item
                    xs={12}
                    sm={2.5}
                    md={2}
                    sx={{
                        borderRight: '1px solid #e0e0e0',
                        backgroundColor: '#ffffff',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 1.5,
                        borderRadius: '8px 0 0 8px',
                    }}
                >
                    <TeamTemplateEditSidenav
                        onMenuItemClick={onMenuItemClick}
                        selectedItem={selectedItem}
                    />
                </Grid>

                {/* Main content area */}
                <Grid
                    item
                    xs={12}
                    sm={9.5}
                    md={9}
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 1.5,
                        backgroundColor: '#ffffff',
                        borderRadius: '0',
                        height: '100%',
                        overflowY: 'auto',
                        '&::-webkit-scrollbar': {
                            display: 'none',
                        },
                        scrollbarWidth: 'none',
                        msOverflowStyle: 'none',
                    }}
                >
                    <Box sx={{ flex: 1 }}>
                        {mainContent}
                    </Box>
                </Grid>

                {/* Right-side template preview */}
                <Grid
                    item
                    xs={12}
                    sm={6}
                    md={5}
                    sx={{
                        padding: 1.5,
                        backgroundColor: '#ffffff',
                        borderRadius: '0 8px 8px 0',
                        borderLeft: '1px solid #e0e0e0',
                        height: '100%',
                    }}
                >
                    {previewContent}
                </Grid>
            </Grid>
        </Grid>
    );
};

export default TeamTemplateEditLayout;

